import { useRef } from 'react';
import { YearDropDown } from '@apply/components';
import { parseInt } from 'lodash';
import { isMobileScreen } from '@apply/ui';
import { useExperienceDateSold } from '../../../../../../fields/ExperienceFields';

interface YearSoldProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
}

export const YearSold: React.FC<YearSoldProps> = ({ experienceId, required = false, readOnly = false }) => {
    const isFirstLoad = useRef(true);
    const [dateSold, set_dateSold] = useExperienceDateSold(experienceId);
    const mobileScreen = isMobileScreen();

    // Normalize incoming value: convert Date → year
    const normalizedDateSold = typeof dateSold === 'string' ? new Date(dateSold) : dateSold;
    const yearValue = normalizedDateSold instanceof Date ? normalizedDateSold.getUTCFullYear() : undefined;

    const handleChange = (value: any) => {
        // Skip the first change triggered by initial load
        if (isFirstLoad.current) {
            isFirstLoad.current = false;

            if (dateSold !== undefined && dateSold !== null) {
                return;
            }
        }

        // Normalize outgoing value
        if (value === null || value === undefined || value === '') {
            set_dateSold(undefined);
        } else {
            const year = parseInt(value);
            // Convert year → Date
            set_dateSold(new Date(Date.UTC(year, 0, 1)));
        }
    };

    return (
        <>
            <YearDropDown
                id='experienceYearSoldDropDown'
                value={yearValue} // must be number | undefined
                onChange={handleChange}
                label=''
                yearStart={1850}
                required={required}
                readOnly={readOnly}
                width={!mobileScreen ? '220px' : '100%'}
            />
        </>
    );
};
